// extracted by mini-css-extract-plugin
module.exports = {"comp":"JG_comp__GA6jJ"};